import { debounce } from 'throttle-debounce';
import { SETTINGS } from '../../utils/constants';
import initAtcPopup from '../../components/atc-popup';
import getLocalePrefix from '../../lib/getLocalePrefix';

const initSearch = () => {
  const predictiveSearchEls = document.querySelectorAll('[data-predictive-search]');
  if (!predictiveSearchEls.length) return;

  predictiveSearchEls.forEach(search => {
    const searchInputEl = search.querySelector('input[type="search"]');
    const resultsEl = search.querySelector('[data-predictive-search-results]');
    if (!searchInputEl || !resultsEl) return;

    const settings = JSON.parse(search.dataset.settings);
    const defaultContentEl = search.querySelector('[data-search-default-content]');
    const clearButtonEl = search.querySelector('[data-search-clear]');

    const updateClearButtonVisibility = () => {
      if (!clearButtonEl) return;
      const hasValue = searchInputEl.value.length > 0;
      clearButtonEl.classList.toggle('hidden', !hasValue);
      clearButtonEl.classList.toggle('flex', hasValue);
    };
    updateClearButtonVisibility();

    const openResults = () => {
      resultsEl.classList.remove('hidden');
      if (defaultContentEl) defaultContentEl.classList.add('hidden');
    };

    const closeResults = () => {
      resultsEl.classList.add('hidden');
      if (defaultContentEl) defaultContentEl.classList.remove('hidden');
    };

    const fetchResults = async (query) => {
      const localePrefix = getLocalePrefix();
      const url = `${window.location.origin}${localePrefix}/search/suggest?q=${encodeURIComponent(query)}&resources[type]=query,${settings?.type}&resources[options][fields]=${settings?.fields}&resources[limit]=${settings?.limit}&resources[limit_scope]=each&resources[options][unavailable_products]=${settings?.oos}&section_id=${settings?.search_bar == 'quick-order' ? 'quick-order-predictive-search' : 'predictive-search'}`;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          closeResults();
          throw new Error(`Fetch failed: ${response.status}`);
        }

        const htmlText = await response.text();
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const section = settings?.search_bar == 'quick-order' ? html.querySelector('#shopify-section-quick-order-predictive-search') : html.querySelector('#shopify-section-predictive-search');

        if (section) {
          resultsEl.innerHTML = section.innerHTML;
          if (settings?.search_bar == 'header') {
            typeof window.ReloadSmartWishlist === 'function' ? await window.ReloadSmartWishlist() : null;
            typeof window.yotpoWidgetsContainer === 'object' && typeof window.yotpoWidgetsContainer.initWidgets === 'function' ? await window.yotpoWidgetsContainer.initWidgets() : null;
          } else {
            initAtcPopup();
          }
          openResults();
        } else {
          closeResults();
        }
      } catch (error) {
        closeResults();
        console.error('Search error:', error);
      }
    };

    const handleInput = () => {
      const value = searchInputEl.value.trim();
      if (value.length <= settings?.trigger - 1) {
        closeResults();
        return;
      }
      fetchResults(value);
    };
    const debouncedHandleInput = debounce(SETTINGS.SEARCH_DEBOUNCE_DELAY, handleInput);
    searchInputEl.addEventListener('input', () => {
      updateClearButtonVisibility();
      debouncedHandleInput();
    });

    if (clearButtonEl) {
      clearButtonEl.addEventListener('click', () => {
        searchInputEl.value = '';
        resultsEl.innerHTML = '';
        closeResults();
        updateClearButtonVisibility();
        searchInputEl.focus();
      });
    }

    document.addEventListener('click', (event) => {
      if (!search.contains(event.target)) {
        searchInputEl.value = '';
        resultsEl.innerHTML = '';
        closeResults();
        updateClearButtonVisibility();
      }
    });
  });
  window.theme.search = { initSearch };
};

export default initSearch;
